import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useReduxLookups } from "hooks/useReduxLookups";
import { actions } from "store/actions";

function useServiceFilter(isVendor) {
  const dispatch = useDispatch();
  const { services = [] } = useReduxLookups(isVendor);
  const rates = useSelector((state) => state.rates || {});

  const serviceOptions = services.map((item) => ({
    label: item.title,
    value: item.id,
  }));

  const [selectedStatuses, setSelectedStatuses] = useState([]);

  const [filterQuery, setFilterQuery] = useState({
    filter: { op: "and", value: [] },
  });

  useEffect(() => {
    dispatch(actions.getRates(filterQuery));
  }, [dispatch, filterQuery]);

  const handleClear = () => {
    setSelectedStatuses([]);
    setFilterQuery({ filter: { op: "and", value: [] } });
  };
  const disabled = false;
  return {
    serviceOptions,
    selectedStatuses,
    setSelectedStatuses,
    filterQuery,
    setFilterQuery,
    handleClear,
    rates,
    disabled,
  };
}

export default useServiceFilter;
